import { StrictMode, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { reconnect } from '@wagmi/core';
import { RouterProvider, createBrowserRouter } from 'react-router';
import { chain, deployment } from './config/chain';
import { API_URL, DEV_WALLET_ENABLED, RPC_URL } from './config/env';
import { ChainClockProvider } from './hooks/chainClock';
import { debugSet } from './lib/debug';
import { AppShell } from './components/layout/AppShell';
import { Landing } from './pages/Landing';
import { wagmiConfig } from './wallet/config';
import './styles/global.css';

const Discovery = lazy(() => import('./pages/Discovery'));
const TokenPage = lazy(() => import('./pages/token/TokenPage'));
const Create = lazy(() => import('./pages/Create'));
const Portfolio = lazy(() => import('./pages/Portfolio'));
const How = lazy(() => import('./pages/How'));
const Lab = lazy(() => import('./pages/Lab'));
const Terms = lazy(() => import('./pages/Terms'));
const Docs = lazy(() => import('./pages/Docs'));
const NotFound = lazy(() => import('./pages/NotFound'));

debugSet('config', { chainId: chain.id, chainName: chain.name, rpcUrl: RPC_URL, apiUrl: API_URL, devWallet: DEV_WALLET_ENABLED, deployment });

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 5_000, refetchOnWindowFocus: false, retry: 1 } },
});

const router = createBrowserRouter([
  {
    element: <AppShell />,
    children: [
      { index: true, element: <Landing /> },
      { path: 'launches', element: <Discovery /> },
      { path: 't/:address', element: <TokenPage /> },
      { path: 'create', element: <Create /> },
      { path: 'portfolio', element: <Portfolio /> },
      { path: 'how', element: <How /> },
      { path: 'docs', element: <Docs /> },
      { path: 'lab', element: <Lab /> },
      { path: 'terms', element: <Terms /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

void reconnect(wagmiConfig);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ChainClockProvider>
        <RouterProvider router={router} />
      </ChainClockProvider>
    </QueryClientProvider>
  </StrictMode>,
);
